import { regex } from '@/utils/regex'
import { data } from '@/utils/data'
import { day, tool } from '@/utils'
import { otherType } from '@/data/insurance'
/**
 * 过滤器
 * 全局过滤器定义
 */

export const mobile = (value) => {
  return (value && value.replace(regex.mobileSecret, '$1****$2')) || value
}

export const IdCard = (value) => {
  return (value && value.replace(regex.idCard, '$1********$2')) || value
}
export function Currency (value, num = 2) {
  /* value = (+value || 0).toFixed(2)
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') */
  return tool.currency(value, num)
}

export function UnitConvert (value) {
  let temp = tool.unitConvert(value)
  return `${temp['num']}${temp['unit']}`
}

export function TableFilter (value, filter) {
  return (value && data[filter](value)) || value
}

export function dayFormat (value, format = 'YYYY-MM-DD') {
  return day.dayFormat(value, format)
}

export function timeFormat (value, format = 'YYYY-MM-DD HH:mm:ss') {
  return day.dayFormat(value, format)
}

export function Format (value, format = 'YYYY-MM-DD') {
  return day.format(value, format)
}

export function unixFormat (value, format = 'YYYY-MM-DD HH:mm:ss') {
  return day.unixFormat(value, format)
}

export function fromNow (value) {
  return day.fromNow(value)
}

export function source (value) {
  return ['', '小程序', '公众号'][+value]
}

export const codeTypeFilter = (value) => {
  let result = otherType.codeType.filter(f => f.value === value)
  if (result && result.length) {
    return result[0].label
  }
}

/**
 * format 值为calc表示需要计算，为空表示不用计算（默认）直接添加 %
 */
export function percent (value, format = '') {
  if (isNaN(value) || !value) {
    return value
  }
  return format === 'calc' ? `${(value * 100).toFixed(2)}%` : `${value}%`
}
/**
 * 格式化日期为：‘YYYY—MM-DD‘格式
 * @param {日期值：‘2020-03-20 18:23:32’} value
 */
export function dateFormat (value) {
  return (value || '').slice(0, 10)
}
/**
 * 去掉html标签
 */
export function dislodgeHtml (value) {
  return (value || '').replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n').replace(/<br\/?>/gi, '\n').replace(/<[^>/]+>/g, '').replace(/(\n)?<\/([^>]+)>/g, '').replace(/\u00a0/g, ' ').replace(/&nbsp;/g, ' ').replace(/<\/?(img)[^>]*>/gi, '').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/<\/?.+?>/g, '')
}

/**
 * 处理传入数据源
 */
export function matchLabel (value, source, valName = 'Value', label = 'Label') {
  if (value === undefined) {
    return value
  }
  let obj = source.find(c => `${c[valName]}`.trim() === `${value}`.trim())
  return (obj && obj[label]) || value
}

const filters = {}
Object.keys(data).forEach(key => {
  filters[key] = (value) => {
    return data[key](value)
  }
})

export const dataFilter = { ...filters }



// WEBPACK FOOTER //
// ./src/filters/index.js